import { FC } from 'react';
import ScanPageContent from './content';
import ScanPageContentCount from './count';
import ScanPageContentCustom from './custom'
import {
  ScanPageContentProps,
  ScanPageContentCountProps,
  ScanPageContentCustomProps,
} from '../../interface';

export type IScanPageContentComponent = FC<ScanPageContentProps> & {
  Count: FC<ScanPageContentCountProps>;
  Custom: FC<ScanPageContentCustomProps>;
};

const TransScanPageContent = ScanPageContent as IScanPageContentComponent;
TransScanPageContent.Count = ScanPageContentCount;
TransScanPageContent.Custom = ScanPageContentCustom;

export default TransScanPageContent;